<template>
  <q-field
      v-bind="allAttrs"
      class="common-field"
      borderless
      :rules="requiredRules"
      stack-label
  >
    <slot />
    <template
        v-if="$slots.prepend"
        v-slot:prepend
    >
      <slot name="prepend" />
    </template>
    <template
        v-if="$slots.control"
        v-slot:control
    >
      <slot name="control" />
    </template>
    <template
        v-if="$slots.append"
        v-slot:append
    >
      <slot name="append" />
    </template>
  </q-field>
</template>

<script>
import Base from './Base'

export default {
  extends: Base,
  inheritAttrs: false,
}
</script>
